import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
// import NProgress from 'nprogress';
import EventBus from '@/utilities/event-bus';
import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';
import { useAuthStore } from '@/modules/auth/store';
import {  getPage, getPerPage } from '@/composables/PaginationComposable';


const STATION_URL = process.env.VUE_APP_API_VERSION + '/station';
export const useStationStore = defineStore('station', () => {
    const authStore = useAuthStore();
    const company_id = computed(() => {
        return authStore.getLoggedUserCompanyId;
    });

    const sortParams = ref('name asc');
    //state
    const editId = ref(null);
    const loading = ref(false);
    const totalRecords = ref(null);


    const stations = ref([]);
    const station = ref({
       name:null
    });

    const params = ref({
        rows: 10,
        sortField: null,
        sortOrder: null,
        page: null,
        sortingInfo: 'created_at desc',
    });

    const fetchAllStations = async (list) => {
        try {

            // NProgress.start();
            loading.value = true;


            //let page_size = params.value.rows ?? '';
            let page_size = getPerPage(list);
            //let page = params.value.page ?? '';
            let page = getPage(list);
            // const sortOrder = getOrderForHttp(list)
            const LINK = STATION_URL + '?company_id=' + company_id.value + '&page_size=' + page_size + '&page=' + (page + 1);
            const response = await authApi.get(LINK, {
             //PARAMS
            });
            if (response.statusCode === 200) {
                stations.value = response.data.data;
                totalRecords.value =  response.data.total;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to fetch stations');
        } finally {
            // NProgress.done();
            loading.value = false;
        }
    };

    const createStation = async () => {
        try {
            EventBus.emit('show-operation-loader');
            const bodyParams = { ...station.value, company_id: company_id.value };
            const response = await authApi.post(STATION_URL, bodyParams);
            if (response.statusCode === 201) {
                // push the data into the appliances.value
                stations.value?.push(response.data);
                showToast(response.toast, 'New Station created successfully');
                return true;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to create station');
        } finally {
            EventBus.emit('hide-operation-loader');
        }
    };



    const updateStation = async () => {
        try {
            EventBus.emit('show-operation-loader');
            const bodyParams = { ...station.value, company_id: company_id.value };
            const response = await authApi.patch(`${STATION_URL}/${editId.value}`, bodyParams);
            if (response.statusCode === 200) {
                const existingData = stations.value.find((station) => station.id === editId.value);
                if (existingData) {
                    const existingDataIndex = stations.value.indexOf(existingData);
                    if (existingDataIndex !== -1) {
                        // replace the updated data into the checklist.value index
                        stations.value[existingDataIndex] = response.data;
                        showToast(response.toast, 'Station updated successfully');
                        return true;
                    }
                }
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to update station');
        } finally {
            EventBus.emit('hide-operation-loader');
        }
    };


    const deleteStation = async (stationId) => {
        try {
            EventBus.emit('show-operation-loader');
            const response = await authApi.delete(`${STATION_URL}/${stationId}`, {
                params: {
                    company_id: company_id.value,
                },
            });
            if (response.statusCode === 200) {
                stations.value = stations.value?.filter((station) => station.id !== stationId);
                showToast(response.toast, 'Station deleted successfully');
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to delete Station');
        } finally {
            EventBus.emit('hide-operation-loader');
        }
    };


    // helpers
    const initStation = () => {
        editId.value = null;
        station.value.name = null;
    };

    const loadStationBody = (stationData) => {
        editId.value = stationData?.id;
        station.value.name = stationData?.name;
    }



    return {
        company_id,
        sortParams,

        //states
        station,
        stations,
        editId,
        loading,
        totalRecords,
        params,

        //actions
        fetchAllStations,
        createStation,
        updateStation,
        deleteStation,

        //helpers
        initStation,
        loadStationBody,

    };
});
